import { Box } from "@mui/material";
import React, { ComponentPropsWithoutRef, useEffect, useState } from "react";
import axiosInstant from "../../../../../api";
import { getEmbed } from "../../../../../api/endpoints";
import { Header } from "./Header";
import { IEmbed } from "../../embedsV2/interface";
import { ConfirmDeleteModal } from "../../embedsV2/ConfirmDelete";
import { StoryForm } from "./storyFormCotainer/StoryForm";
import { DotLottleLoader } from "../../../../../components/Loader";
import { MainContainer } from "../../../../../components/ContentWrapper";
import { VideoSection } from "../../../../../components/videoSection/VideoSection";

interface SelectedEmbedCardProps extends ComponentPropsWithoutRef<"div"> {
  brandId: number;
  embedId: number;
  onClose?: () => void;
  onUpdate?: () => Promise<void>;
  onDelete?: () => void;
}

export function SelectedEmbedCardV2({
  embedId,
  onDelete,
  brandId,
  ...props
}: SelectedEmbedCardProps) {
  const [embed, setEmbed] = useState<IEmbed>();
  const [videoListKey, setVideoListKey] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const fetchEmbed = async () => {
    const { data } = await axiosInstant.get(getEmbed(embedId));
    if (data) setEmbed(data);
  };

  const refetch = () => {
    fetchEmbed();
    // Adding/removing videos happens outside VideoSection's query model —
    // remount it so the list reloads.
    setVideoListKey((k) => k + 1);
  };

  useEffect(() => {
    fetchEmbed();
  }, [embedId]);

  if (!embed) return <DotLottleLoader />;
  return (
    <MainContainer>
      <Header
        {...props}
        refetch={refetch}
        embed={embed}
        setShowSettingsModal={setShowSettingsModal}
        onDelete={() => setShowDeleteModal(true)}
      />
      <Box className="mt-6">
        <VideoSection
          key={videoListKey}
          brandId={brandId || undefined}
          features={{ sort: true, filters: true, inlineDetail: true }}
          isStoryVideos
          excludeFilterKeys={["embed", "brandId"]}
          menuContext={{ embedId }}
          emptyTitle="No videos in this story yet"
          emptyBody="Add videos to this story from the videos page."
          detailContainerClassName="!py-0"
        />
      </Box>
      <ConfirmDeleteModal
        show={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        onOkay={onDelete}
      />
      {embed && showSettingsModal && (
        <StoryForm
          embed={embed}
          onClose={() => setShowSettingsModal(false)}
          onComplete={refetch}
        />
      )}
    </MainContainer>
  );
}
